<div class="profile-container">
  <div class="profile-header">
    <div class="profile-icon-container">
      <mat-icon class="profile-icon">person</mat-icon>
    </div>
    <div class="profile-details">
      <span class="profile-name" *ngIf="patient?.firstName || patient?.lastName">{{ patient.firstName }} {{ patient.lastName }}</span>
      <span class="profile-email" *ngIf="patient?.email">{{ patient.email }}</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <mat-list>
    <mat-list-item class="clickable" (click)="onProfileManage()">
      <mat-icon matListItemIcon mat-list-icon>account_circle</mat-icon>
      <span matListItemTitle mat-line>Profile</span>
    </mat-list-item>
    <mat-list-item class="clickable" (click)="onProfileLogout()">
      <mat-icon matListItemIcon mat-list-icon>logout</mat-icon>
      <span matListItemTitle mat-line>Logout</span>
    </mat-list-item>
  </mat-list>
</div>
